const initialState = {
  iCompletoStep: 0,
  iCompletoNumero: null,
  iCompletoCpa: null,
  consultaCpa: null,
  iCompletoRequestCpa: false,
  requestConsultaCpa: false,
  iCompletoImpresora: null,
  iCompletoImpresoraNombre: null,
  iMinimoSaveStatus: null,
  iCompletoShowSinCupo: false,
  iCompletoValidacionExterna: false,
  iCompletoRequestConfirmarArribo: false,
  iCompletoValidacionResponse: null,
  iCompletoShowValidacionModal: false,
  iCompletoSaveResponse: null,
  iCompletoShowSaveModal: false,
  iCompletoCpaTextValue: null,
  abandonoStep: 0,
  desabandonoStep: 0,
  disponibilidadCupoStep: 0,
  rechazoStep: 0,
  reimpresionStep: 0,
  busquedaCpaStep: 0,
  estadoCpa: [],
  minimblq: '',
  detalleCompletoCpa: [],
  abandonoSaveResponse: null,
  abandonoShowSaveModal: false,
  desabandonoSaveResponse: null,
  desabandonoShowSaveModal: false,
  showCircular: false,
  anulacionIngresoStep: 0,
  anulacionIngresoDeleteResponse: null,
  anulacionIngresoShowDeleteModal: false,
  cpaConsultaCupo: null,
  controlTurno: null,
  controlTurnoFiltro: [{}],
  controlTurnoAnchoColumna: [{}],
  controlTurnoSorting: [{}],
  controlTurnoSelection: [],
  requestingControlTurno: false,
  sinCupo: null,
  sinCupoFiltro: [{}],
  sinCupoAnchoColumna: [{}],
  sinCupoSorting: [{}],
  sinCupoSelection: [],
  consultaCupoTextValue: '',
  cpaPlaya: null,
  sinAutorizar: null,
  cpaAbandonada: null,
  showMsgToast: false,
  showInfoVolcadoras: false,
  totalCamionesCereal: '',
  camionesPedidos: '',
  turnosPendientesPlaya: 0,
  requestingCpaPlaya: false,
  updateByPresunta: false,
  notificacionesChofer: [],
  cortesPedidos: '',
  camionPenalizado: '',
  vencimientoPenalizacion: '',
  motivoPenalizacion: '',
  dialogoPenalizacion: false,
  dialogoDescargable: false,
  acopladoPenalizado: '',
  vencimientoPenalizacionAcoplado: '',
  motivoPenalizacionAcoplado: '',
  ctgPenalizada: '',
  cpaEntrePlayaCalado: [],
  receiveCpaEntrePlayaCalado: false,
  camListosParaBruto: [],
  receiveCamListosParaBruto: false,
  receiveCamEntreBrutoDestare: false,
  camEntreBrutoDestare: [],
  procesandoCPA: false,
  patenteCamion: false,
  patenteAcoplado: false,
  actualizarPresunta: false
}

export function nextStep ({ step, max = 4, inc = 1 }) {
  const newStep = step + inc <= max
    ? step + inc : max
  return newStep
}

export function prevStep ({ step, min = 0, inc = -1 }) {
  const newStep = step + inc >= min
    ? step + inc : min
  return newStep
}

export default function reducer (state = initialState, action) {
  switch (action.type) {
    case 'REQUEST_CONSULTA_CPA':
      return {
        ...state,
        requestConsultaCpa: true
      }
    case 'RECEIVE_CONSULTA_CPA':
      return {
        ...state,
        requestConsultaCpa: false,
        consultaCpa: action.cpa
      }
    case 'IMINIMO_RESET_STATUS':
      return {
        ...state,
        iMinimoSaveStatus: null,
        camionPenalizado: '',
        vencimientoPenalizacion: '',
        motivoPenalizacion: '',
        acopladoPenalizado: '',
        vencimientoPenalizacionAcoplado: '',
        motivoPenalizacionAcoplado: ''
      }
    case 'IMINIMO_SAVE_STATUS':
      return {
        ...state,
        iMinimoSaveStatus: action.saveStatus
      }
    case 'TRANSPORTE_TERRESTRE_PENALIZADO':
      return {
        ...state,
        camionPenalizado: action.patente,
        vencimientoPenalizacion: action.vencimiento,
        motivoPenalizacion: action.motivo
      }
    case 'CAMION_PENALIZADO_EN_PLAYA':
      return {
        ...state,
        ctgPenalizada: action.numeroPenalizado
      }
    case 'TRANSPORTE_TERRESTRE_ACOPLADO':
      return {
        ...state,
        acopladoPenalizado: action.patente,
        vencimientoPenalizacionAcoplado: action.vencimiento,
        motivoPenalizacionAcoplado: action.motivo
      }
    case 'SHOW_DIALOGO_PENALIZACION':
      return {
        ...state,
        dialogoPenalizacion: action.newValue
      }
    case 'SHOW_DIALOGO_DESCARGABLE':
      return {
        ...state,
        dialogoDescargable: action.payload.newValue,
        patenteCamion: action.payload.camion,
        patenteAcoplado: action.payload.acoplado
      }
    case 'SELECT_PRINTER_ICOMPLETO':
      return {
        ...state,
        iCompletoImpresora: action.printer || null,
        iCompletoImpresoraNombre: action.printerName || null
      }
    case 'RESET_PRINTER_ICOMPLETO':
      return {
        ...state,
        iCompletoImpresora: null,
        iCompletoImpresoraNombre: null
      }
    case 'ICOMPLETO_NEXT_STEP':
      return {
        ...state,
        iCompletoStep: nextStep({ step: state.iCompletoStep })
      }
    case 'ICOMPLETO_PREV_STEP':
      return {
        ...state,
        iCompletoStep: prevStep({ step: state.iCompletoStep })
      }
    case 'REIMPRESION_NEXT_STEP':
      return {
        ...state,
        reimpresionStep: nextStep({ step: state.reimpresionStep })
      }
    case 'BUSQUEDACPA_NEXT_STEP':
      return {
        ...state,
        busquedaCpaStep: nextStep({ step: state.busquedaCpaStep })
      }
    case 'BUSQUEDACPA_CPA':
      return {
        ...state,
        estadoCpa: action.estadoCpa
      }
    case 'BUSQUEDACPA_DETALLE':
      return {
        ...state,
        detalleCompletoCpa: action.detalleCompletoCpa
      }
    case 'END_BUSQUEDACPA':
      return {
        ...state,
        busquedaCpaStep: 0,
        estadoCpa: [],
        detalleCompletoCpa: []
      }
    case 'REIMPRESION_PREV_STEP':
      return {
        ...state,
        reimpresionStep: prevStep({ step: state.reimpresionStep })
      }
    case 'END_REIMPRESION':
      return {
        ...state,
        reimpresionStep: 0,
        iCompletoNumero: null,
        iCompletoCpa: null,
        iCompletoRequestCpa: false
      }
    case 'ABANDONO_NEXT_STEP':
      return {
        ...state,
        abandonoStep: nextStep({ step: state.abandonoStep })
      }
    case 'ABANDONO_PREV_STEP':
      return {
        ...state,
        abandonoStep: prevStep({ step: state.abandonoStep })
      }
    case 'RECHAZO_NEXT_STEP':
      return {
        ...state,
        rechazoStep: nextStep({ step: state.rechazoStep })
      }
    case 'RECHAZO_PREV_STEP':
      return {
        ...state,
        rechazoStep: prevStep({ step: state.rechazoStep })
      }
    case 'END_ABANDONO':
      return {
        ...state,
        abandonoStep: 0,
        abandonoSaveResponse: null
      }
    case 'END_RECHAZO':
      return {
        ...state,
        rechazoStep: 0,
        rechazoSaveResponse: null
      }
    case 'HIDE_MODAL_ABANDONO_STATUS':
      return {
        ...state,
        abandonoShowSaveModal: false
      }
    case 'ABANDONO_SAVE_STATUS':
      return {
        ...state,
        abandonoSaveResponse: action.abandonoSaveResponse,
        abandonoShowSaveModal: action.abandonoSaveResponse.error
      }
    case 'SHOW_NO_ABANDONABLE':
      return {
        ...state,
        abandonoShowSaveModal: true,
        abandonoSaveResponse: action.abandonoSaveResponse
      }
    case 'HIDE_NO_ABANDONABLE':
      return {
        ...state,
        abandonoShowSaveModal: false,
        abandonoSaveResponse: null
      }
    case 'DESABANDONO_NEXT_STEP':
      return {
        ...state,
        desabandonoStep: nextStep({ step: state.desabandonoStep })
      }
    case 'DESABANDONO_PREV_STEP':
      return {
        ...state,
        desabandonoStep: prevStep({ step: state.desabandonoStep })
      }
    case 'END_DESABANDONO':
      return {
        ...state,
        desabandonoStep: 0,
        desabandonoSaveResponse: null
      }
    case 'DISPONIBILIDAD_CUPO_NEXT_STEP':
      return {
        ...state,
        cpaConsultaCupo: action.data,
        disponibilidadCupoStep: nextStep({ step: state.disponibilidadCupoStep })
      }
    case 'DISPONIBILIDAD_CUPO_PREV_STEP':
      return {
        ...state,
        disponibilidadCupoStep: prevStep({ step: state.disponibilidadCupoStep })
      }
    case 'END_DISPONIBILIDAD_CUPO':
      return {
        ...state,
        disponibilidadCupoStep: 0
      }
    case 'SHOW_NO_DESABANDONABLE':
      return {
        ...state,
        desabandonoShowSaveModal: true,
        desabandonoSaveResponse: action.desabandonoSaveResponse
      }
    case 'HIDE_NO_DESABANDONABLE':
      return {
        ...state,
        desabandonoShowSaveModal: false,
        desabandonoSaveResponse: null
      }
    case 'ICOMPLETO_REQUEST_CPA':
      return {
        ...state,
        iCompletoRequestCpa: true
      }
    case 'ICOMPLETO_RECEIVE_CPA':
      return {
        ...state,
        iCompletoRequestCpa: false,
        iCompletoCpa: action.cpa
      }
    case 'ICOMPLETO_SHOW_SIN_CUPO':
      return {
        ...state,
        iCompletoShowSinCupo: true
      }
    case 'ICOMPLETO_HIDE_SIN_CUPO':
      return {
        ...state,
        iCompletoShowSinCupo: false
      }
    case 'END_ICOMPLETO':
      return {
        ...state,
        iCompletoStep: 0,
        iCompletoNumero: null,
        iCompletoCpa: null,
        iCompletoRequestCpa: false,
        iCompletoShowSinCupo: false,
        iCompletoValidacionExterna: false,
        iCompletoRequestConfirmarArribo: false,
        iCompletoValidacionResponse: null
      }
    case 'RESET_ICOMPLETO':
      return {
        ...state,
        iCompletoStep: 0,
        iCompletoNumero: null,
        iCompletoCpa: null,
        iCompletoRequestCpa: false,
        iCompletoShowSinCupo: false,
        iCompletoValidacionExterna: false,
        iCompletoRequestConfirmarArribo: false,
        iCompletoValidacionResponse: null
      }
    case 'ICOMPLETO_UPDATE_VALUE_CPA':
      return {
        ...state,
        iCompletoCpaTextValue: action.value
      }
    case 'CONSULTA_CUPO':
      return {
        ...state,
        cpaConsultaCupo: action.data
      }
    case 'RESET_CONSULTA_CUPO':
      return {
        ...state,
        cpaConsultaCupo: null
      }
    case 'UPDATE_VALUE_CONSULTA_CUPO':
      return {
        ...state,
        cpa: null,
        consultaCupoTextValue: action.value
      }
    case 'CAMBIAR_VALIDACION_EXTERNA':
      return {
        ...state,
        iCompletoValidacionExterna: !state.iCompletoValidacionExterna
      }
    case 'REQUEST_CONFIRMAR_ARRIBO':
      return {
        ...state,
        iCompletoRequestConfirmarArribo: true,
        iCompletoValidacionResponse: null
      }
    case 'RECEIVE_CONFIRMAR_ARRIBO':
      return {
        ...state,
        iCompletoRequestConfirmarArribo: false,
        iCompletoValidacionResponse: action.confirmarArribo.message,
        iCompletoShowValidacionModal: action.confirmarArribo.error
      }
    case 'HIDE_MODAL_INFO_VALIDACION':
      return {
        ...state,
        iCompletoShowValidacionModal: false
      }
    case 'ICOMPLETO_SAVE_STATUS':
      return {
        ...state,
        iCompletoSaveResponse: action.iCompletoSaveResponse.message,
        iCompletoShowSaveModal: action.iCompletoSaveResponse.error
      }
    case 'HIDE_MODAL_INFO_COMPLETO_SAVE':
      return {
        ...state,
        iCompletoShowSaveModal: false
      }
    case 'CONTROL_TURNO':
      return {
        ...state,
        requestingControlTurno: false,
        controlTurno: action.data,
        controlTurnoSelection: []
      }
    case 'REQUEST_CONTROL_TURNO':
      return {
        ...state,
        requestingControlTurno: true
      }
    case 'RESET_CONTROL_TURNO':
      return {
        ...state,
        requestingControlTurno: false,
        controlTurno: null
      }
    case 'ACTUALIZAR_FILTROS':
      return {
        ...state,
        controlTurnoFiltro: action.filters
      }
    case 'ACTUALIZAR_ANCHO_COLUMNA':
      return {
        ...state,
        controlTurnoAnchoColumna: action.columnWidths
      }
    case 'ACTUALIZAR_SORTING':
      return {
        ...state,
        controlTurnoSorting: action.sorting
      }
    case 'ACTUALIZAR_SELECTION':
      return {
        ...state,
        controlTurnoSelection: action.selection
      }
    case 'SIN_CUPO':
      return {
        ...state,
        sinCupo: action.data
      }
    case 'RESET_SIN_CUPO':
      return {
        ...state,
        sinCupo: null
      }
    case 'CPA_EN_PLAYA':
      return {
        ...state,
        requestingCpaPlaya: false,
        cpaPlaya: action.data
      }
    case 'RESET_CPA_EN_PLAYA':
      return {
        ...state,
        cpaPlaya: null
      }
    case 'RECEIVE_TURNOS_PENDIENTES_PLAYA':
      return {
        ...state,
        turnosPendientesPlaya: action.data['turnosPendientesEgresoPlaya']
      }
    case 'CPA_SIN_AUTORIZAR':
      return {
        ...state,
        sinAutorizar: action.data
      }
    case 'RESET_CPA_SIN_AUTORIZAR':
      return {
        ...state,
        sinAutorizar: null
      }
    case 'CPA_ABANDONADA':
      return {
        ...state,
        cpaAbandonada: action.data
      }
    case 'ACTUALIZAR_FILTROS_SINCUPOS':
      return {
        ...state,
        sinCupoFiltro: action.filters
      }
    case 'ACTUALIZAR_ANCHO_COLUMNA_SINCUPOS':
      return {
        ...state,
        sinCupoAnchoColumna: action.columnWidths
      }
    case 'ACTUALIZAR_SORTING_SINCUPOS':
      return {
        ...state,
        sinCupoSorting: action.sorting
      }
    case 'ACTUALIZAR_SELECTION_SINCUPOS':
      return {
        ...state,
        sinCupoSelection: action.selection
      }
    case 'REQUEST_CPA_EN_PLAYA':
      return {
        ...state,
        requestingCpaPlaya: true
      }
    case 'ANULACION_INGRESO_NEXT_STEP':
      return {
        ...state,
        anulacionIngresoStep: nextStep({ step: state.anulacionIngresoStep })
      }
    case 'ANULACION_INGRESO_PREV_STEP':
      return {
        ...state,
        anulacionIngresoStep: prevStep({ step: state.anulacionIngresoStep })
      }
    case 'END_ANULACION_INGRESO':
      return {
        ...state,
        anulacionIngresoStep: 0,
        anulacionIngresoDeleteResponse: null
      }
    case 'HIDE_MODAL_ANULACION_INGRESO_STATUS':
      return {
        ...state,
        anulacionIngresoShowDeleteModal: false
      }
    case 'ANULACION_INGRESO_STATUS':
      return {
        ...state,
        anulacionIngresoDeleteResponse: action.anulacionIngresoDeleteResponse.message,
        anulacionIngresoShowDeleteModal: action.anulacionIngresoDeleteResponse.error
      }
    case 'SHOW_TOAST':
      return {
        ...state,
        showMsgToast: true
      }
    case 'HIDE_TOAST':
      return {
        ...state,
        showMsgToast: false
      }
    case 'SHOW_INFO_VOLCADORAS':
      return {
        ...state,
        showInfoVolcadoras: action.newValue
      }
    case 'REQUEST_ESTADO_FORMULARIO_MINIMO':
      return {
        ...state,
        minimblq: ''
      }
    case 'RECEIVE_ESTADO_FORMULARIO_MINIMO':
      return {
        ...state,
        minimblq: action.minimblq && action.minimblq['valor']
      }
    case 'RECEIVE_PROMEDIO_CAMION':
      return {
        ...state,
        promedioPesoCamion: action.peso
      }
    case 'REQUEST_UPDATE_PRESUNTA':
      return {
        ...state,
        updateByPresunta: true
      }
    case 'RECEIVE_UPDATE_PRESUNTA':
      return {
        ...state,
        updateByPresunta: false
      }
    case 'REQUEST_PRESUNTA':
      return {
        ...state,
        procesandoCPA: true
      }
    case 'RECEIVE_PRESUNTA':
      return {
        ...state,
        procesandoCPA: false
      }
    case 'RECEIVE_TOTAL_CAMIONES_CEREAL':
      return {
        ...state,
        totalCamionesCereal: action.total['filas']
      }
    case 'RECEIVE_PEDIDO_EGRESO_PLAYA':
      return {
        ...state,
        camionesPedidos: action.pedido
      }
    case 'RECEIVE_NOTIFICACION_CHOFER':
      return {
        ...state,
        notificacionesChofer: action.data
      }

    case 'RECEIVE_ESTADO_PEDIDOS_CEREAL':
      return {
        ...state,
        cortesPedidos: action.data
      }
    case 'REQUEST_CAMIONES_ENTRE_PLAYA_CALADO':
      return {
        ...state,
        receiveCpaEntrePlayaCalado: false
      }
    case 'CAMIONES_ENTRE_PLAYA_CALADO':
      return {
        ...state,
        cpaEntrePlayaCalado: action.data,
        receiveCpaEntrePlayaCalado: true
      }
    case 'REQUEST_CAMIONES_LISTOS_PARA_BRUTO':
      return {
        ...state,
        receiveCamListosParaBruto: false
      }
    case 'CAMIONES_LISTOS_PARA_BRUTO':
      return {
        ...state,
        camListosParaBruto: action.data,
        receiveCamListosParaBruto: true
      }
    case 'REQUEST_CAMIONES_ENTRE_BRUTO_DESTARE':
      return {
        ...state,
        receiveCamEntreBrutoDestare: false
      }
    case 'CAMIONES_ENTRE_BRUTO_DESTARE':
      return {
        ...state,
        camEntreBrutoDestare: action.data,
        receiveCamEntreBrutoDestare: true
      }
    case 'SET_ACTUALIZACION_PRESUNTA':
      return {
        ...state,
        actualizarPresunta: action.newValue
      }
    case 'SHOW_CIRCULAR':
      return {
        ...state,
        showCircular: true
      }
    case 'HIDE_CIRCULAR':
      return {
        ...state,
        showCircular: false
      }
    default:
      return state
  }
}
